import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../table/Table"; // new
import { BiChevronDown } from "react-icons/bi";
import { getAuthorization } from "../../axios/AxiosAut";
import { getCurrentUser } from "../../redux/slices/user/userSlice";

function UserProfile() {
  const dispatch = useDispatch();
  const [UserGroups, setUserGroups] = useState([]);

  useEffect(() => {
    //Get current user details
    dispatch(getCurrentUser());
    //Get user groups
    getAuthorization()
      .get("company/user_groups/")
      .then((res) => {
        setUserGroups(res.data);
      })
      .catch((err) => {
        console.log("Error in getting user groups", err);
      });
  }, []);
  const Permissions = useSelector((state) => state.user.userPermissions);
  const changecompany = Permissions.find(
    (o) => o.codename === "change_company"
  );

  const UserDetails = useSelector((state) => state.user.currentUser);
  const data = UserGroups;
  const columns = React.useMemo(
    () => [
      {
        Header: "Group Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "descriptions",
        // Cell: StatusPill,
      },
      {
        Header: "Action",
        // accessor: "action",
      },

      //filer if required

      // {
      //   Header: "Job Role",
      //   accessor: "role",
      //   // Filter: SelectColumnFilter, // new
      //   filter: "includes",
      // },
    ],
    []
  );

  return (
    <>
      <div className="ml-8 container w-auto mb-7">
        <div className="w-full flex">
          <div>
            <h2 className="font-Montserrat text-xl font-bold text-black">
              User profile page  
            </h2>
            <div className="border-b-2 border-blue-200 w-24"></div>
         
          </div>
          <svg className="mt-1.5 ml-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.38533 2.82133L0.958667 11.2473L0 16L4.75133 15.0413L13.1787 6.61467L9.38533 2.82133ZM2.47267 12.75L1.906 12.1833L9.33333 4.76667L9.89933 5.33267L2.47267 12.75ZM3.81133 14.0887L3.24467 13.522L10.672 6.10533L11.2387 6.672L3.81133 14.0887ZM16 3.79267L14.1227 5.67133L10.3287 1.87733L12.206 0L16 3.79267Z" fill="#1F78B4"/>
</svg>
        </div>
      </div>
      {!changecompany === undefined ||
      changecompany?.codename === "change_company" ? (
        <div className="flex justify-center">
          <select
            className="form-select appearance-none
            block
            w-1/4
            px-4
            py-3
            text-sm
            font-Montserrat
            text-gray-700
            bg-white bg-clip-padding bg-no-repeat
            border border-solid border-gray-100
            rounded-lg
            transition
            ease-in-out
            m-0
            focus:text-gray-700 focus:border-blue-100 focus:outline-none"
            aria-label="Default select example"
          >
            <option selected>The company name</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>
        </div>
      ) : null}

      <div className="flex mt-7 ml-3">
        <img
          className="object-cover w-20 h-20 rounded-full mx-6"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=="
          alt="Avatar"
        />
        <div className="flex flex-col space-y-1 w-1/2">
          <h2 className="font-Roboto text-base">{`${UserDetails.first_name} ${UserDetails.last_name}`}</h2>
          <h3 className="font-Roboto text-sm text-gray-300">Job Role</h3>

          <p className="font-Roboto text-gray-dark text-sm">
            {`${UserDetails.about}`}
          </p>
        </div>
      </div>
      <div className="flex flex-col space-y-2 w-1/2">
        <div className="mt-7 ml-8">
          <p className="font-Montserrat font-semibold text-base text-blue-100 mb-4">
            Address & contact info
            <div className="border-b-2 border-blue-200 w-10" />
          </p>
          <div className="space-y-1">
            <div className="flex flex-row space-x-1">
              <h3 className="font-Roboto text-xs text-gray-300">
                Postal Code:
              </h3>
              <p className="font-Roboto text-xs">{`${UserDetails.postal_code}`}</p>
            </div>
            <div className="flex flex-row space-x-1">
              <h3 className="font-Roboto text-xs text-gray-300">Address:</h3>
              <p className="font-Roboto text-xs">#Block Street 17</p>
            </div>
            <div className="flex flex-row space-x-1">
              <h3 className="font-Roboto text-xs text-gray-300">Phone:</h3>
              <p className="font-Roboto text-xs">{`${UserDetails.phone_number}`}</p>
            </div>
            <div className="flex flex-row space-x-1">
              <h3 className="font-Roboto text-xs text-gray-300">Email:</h3>

              <p className="font-Roboto text-xs">{`${UserDetails.email}`}</p>
            </div>
          </div>
          <div className="mt-4">
            <p className="font-Montserrat font-semibold text-base text-blue-100">
              Groups Involved
              <div className="border-b-2 border-blue-200 w-10" />
            </p>
          </div>
        </div>
      </div>
      <div className="min-h-screen">
        <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
          <div className="mt-1">
            <Table columns={columns} data={data} text="Undefined" />
          </div>
          <div className="flex  font-Montserrat mt-8">
            <div className=" inline-flex w-16 mt-3 ml-1 mr-2 bg-blue-200 rounded-full h-0.5 "></div>
            <p className="text-blue-200 font-Montserrat font-medium">
              Current Copmany
            </p>
          </div>
          <div className=" flex flex-wrap px-4 py-4 broder-2 rounded-lg w-1/3 mt-4 shadow-md border-gray-50 bg-white ">
            <div className="text-center mx-auto my-4">
            <svg
            className="mx-auto"
                width="39"
                height="45"
                viewBox="0 0 39 45"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.0938 26.3591C38.0938 31.2705 36.0899 35.9807 32.5231 39.4535C28.9562 42.9264 24.1185 44.8774 19.0742 44.8774C14.0299 44.8774 9.19224 42.9264 5.62538 39.4535C2.05853 35.9807 0.0546876 31.2705 0.0546875 26.3591C0.0546875 21.7124 2.09722 16.3578 6.12647 10.4446C6.24668 10.2682 6.40144 10.1165 6.58191 9.99838C6.76237 9.88024 6.965 9.79791 7.17818 9.7561C7.39137 9.7143 7.61093 9.71384 7.8243 9.75475C8.03766 9.79567 8.24065 9.87715 8.42163 9.99453L15.0942 14.3258L21.4719 1.28529C21.5857 1.05263 21.7551 0.849942 21.966 0.694265C22.1769 0.538588 22.4231 0.434465 22.6839 0.390643C22.9446 0.346821 23.2124 0.364581 23.4647 0.442431C23.717 0.52028 23.9464 0.655945 24.1336 0.838028C27.1817 3.80056 30.6621 7.39432 33.3652 11.5853C36.5468 16.5188 38.0936 21.3513 38.0936 26.3589L38.0938 26.3591Z"
                  fill="#00EDDF"
                />
                <path
                  d="M19.0742 44.8796C24.1185 44.8796 28.9562 42.9285 32.5231 39.4557C28.5754 27.7965 24.826 22.2518 15.0942 14.328L8.42163 9.99669C8.24065 9.8793 8.03766 9.79782 7.8243 9.75691C7.61093 9.716 7.39137 9.71646 7.17818 9.75826C6.965 9.80007 6.76237 9.8824 6.58191 10.0005C6.40144 10.1187 6.24668 10.2703 6.12647 10.4468C2.09722 16.3599 0.0546875 21.7146 0.0546875 26.3613C0.0546875 31.2726 2.05853 35.9828 5.62538 39.4557C9.19224 42.9285 14.0299 44.8796 19.0742 44.8796Z"
                  fill="#2A91D7"
                />
              </svg>
            <div className="text-black font-semibold text-base font-Montserrat mt-4 text-center mx-auto">
              Current Company
            </div>
            <div className="text-black font-medium text-sm font-Montserrat mt-2 text-center mx-auto">
              company@gmail.com
            </div>
            </div>
          </div>
          <div className="flex flex-row justify-center space-x-144 my-10">
        <button
          type="button"
          className="text-red-600 font-Montserrat font-medium text-lg"
          // onClick={() =>
          //   Navigate("/dashboard/management/customer-dashboard")
          // }
        >
          Go Back
        </button>
        <button
          type="submit"
          className="text-blue-200  font-Montserrat font-medium text-lg place-content-center rounded-md py-1 px-16 flex flex-shrink-1 "
        >
          <svg className="mt-1.5 mr-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.38533 2.82133L0.958667 11.2473L0 16L4.75133 15.0413L13.1787 6.61467L9.38533 2.82133ZM2.47267 12.75L1.906 12.1833L9.33333 4.76667L9.89933 5.33267L2.47267 12.75ZM3.81133 14.0887L3.24467 13.522L10.672 6.10533L11.2387 6.672L3.81133 14.0887ZM16 3.79267L14.1227 5.67133L10.3287 1.87733L12.206 0L16 3.79267Z" fill="#1F78B4"/>
</svg>

          Edit User
        </button>
      </div>
        </main>
      </div>
    </>
  );
}

export default UserProfile;
